import styled from 'styled-components';
import { Dialog, Select, Toolbar, AppBar, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

// CONSTANTS
import { SANTAS_GRAY_2 } from '@/constants/colors';
import { breakpoints } from '@/utility/breakpoints';

export const WriteReviewContainer = styled(Dialog)`
  &.review-dialog--iframe {
    max-height: 940px;

    .review-dialog__footer {
      position: static;
    }
  }
`;

export const WriteReviewContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 110px 0;
  max-width: 730px;
  margin: 0 auto;

  ${breakpoints.down('sm')} {
    padding: 60px;
  }

  ${breakpoints.down('xs')} {
    padding: 60px 24px;
  }

  .write-review-content {
    &__rating {
      margin: 40px 0;
    }
  }
`;

export const SelectStyled = styled(Select)`
  text-align: left;

  .MuiSelect-root {
    padding-right: 30px;
    padding-left: 55px;

    &:before {
      content: '${p => p.filterLabel}: ';
    }
  }

  .dropdown-label {
    color: ${SANTAS_GRAY_2};
    white-space: nowrap;
  }

  .MuiSelect-iconOutlined {
    right: auto;
    left: 18px;
  }
`;

export const CloseIconStyled = styled(CloseIcon)`
  font-size: 24px;
`;

export const HeaderToolbar = styled(Toolbar)`
  justify-content: space-between;
  min-height: 70px;

  .app-logo {
    max-width: 81px;
    width: 100%;
    height: auto;
  }
`;

export const FooterAppBar = styled(AppBar)`
  top: auto;
  bottom: 0;
`;

export const ButtonStyled = styled(Button)`
  width: 130px;
`;

export default WriteReviewContent;
